// src/components/charts/StatsCards.js
import React from 'react';

const StatsCards = ({ stats }) => {
  const cards = [
    { 
      titulo: 'Usuarios Totales', 
      valor: stats.total_usuarios, 
      icono: '👥',
      color: 'var(--color-primario)',
      extra: `+${stats.usuarios_ultimo_dia} hoy`
    },
    { 
      titulo: 'Historias Creadas', 
      valor: stats.total_historias, 
      icono: '📖',
      color: 'var(--color-secundario)'
    },
    { 
      titulo: 'Imágenes Generadas', 
      valor: stats.total_imagenes, 
      icono: '🖼️',
      color: 'var(--color-acento)'
    },
    { 
      titulo: 'Tokens Consumidos', 
      valor: stats.tokens_totales?.toLocaleString() || '0', 
      icono: '⚡',
      color: '#ff6b6b'
    }
  ];

  return (
    <div className="stats-cards">
      {cards.map((card, index) => (
        <div key={index} className="stat-card" style={{ borderTop: `4px solid ${card.color}` }}>
          <div className="stat-icon">{card.icono}</div>
          <div className="stat-content">
            <div className="stat-titulo">{card.titulo}</div>
            <div className="stat-valor">{card.valor}</div>
            {card.extra && <div className="stat-extra">{card.extra}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;